import React from 'react';
import { BoxIcon } from 'lucide-react';
interface Props {
  icon: BoxIcon;
  label: string;
  value: string | number;
  subtext?: string;
  color?: 'accent' | 'success' | 'warning' | 'error';
}
export const StatCard = ({
  icon: Icon,
  label,
  value,
  subtext,
  color = 'accent'
}: Props) => {
  const colorStyles = {
    accent: 'text-accent-light group-hover:border-accent/50',
    success: 'text-status-success group-hover:border-status-success/50',
    warning: 'text-status-warning group-hover:border-status-warning/50',
    error: 'text-status-error group-hover:border-status-error/50'
  };
  return <div className="bg-surface-light p-3 sm:p-6 rounded-none border border-surface-border 
                 hover:bg-surface-mid transition-colors duration-200 group" data-id="element-1350">
      <div className="flex items-start gap-3 sm:gap-4" data-id="element-1351">
        <div className={`p-2 sm:p-3 bg-surface rounded-none border border-surface-border 
                    transition-colors shrink-0 ${colorStyles[color]}`} data-id="element-1352">
          <Icon size={16} className={`sm:w-5 sm:h-5 ${colorStyles[color]}`} aria-hidden="true" data-id="element-1353" />
        </div>
        <div className="min-w-0" data-id="element-1354">
          <h3 className="text-sm font-medium text-gray-300 font-mono uppercase tracking-wide 
                     group-hover:text-white transition-colors mb-1 sm:mb-2" data-id="element-1355">
            {label}
          </h3>
          <div className="space-y-0.5" data-id="element-1356">
            <p className="text-lg sm:text-xl font-semibold text-white truncate" data-id="element-1357">
              {value}
            </p>
            {subtext && <p className="text-xs text-gray-300 font-mono transition-colors truncate" data-id="element-1358">
                {subtext}
              </p>}
          </div>
        </div>
      </div>
    </div>;
};